import React, { forwardRef } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { useGetOverrideBreadcrumbLink } from '@common/contexts/breadcrumb-link';
import { Link } from '@mui/material';

const BreadcrumbLink = forwardRef((props, ref) => {
  return (
    <Link component={RouterLink} {...props} ref={ref} color="primary" underline="hover" />
  );
});

const getStrippedPath = location =>
  `${location.pathname.split('/').slice(0, -1).join('/')}${location.search}`;

const Breadcrumb = ({ title, to, autoCalcPath }) => {
  const location = useLocation();

  const overrideBreadcrumbLink = useGetOverrideBreadcrumbLink(to);
  return to || overrideBreadcrumbLink || autoCalcPath ? (
    <BreadcrumbLink to={overrideBreadcrumbLink || to || getStrippedPath(location)}>
      {title}
    </BreadcrumbLink>
  ) : (
    title
  );
};

export default Breadcrumb;
